import React from 'react'
import {Nullable} from '../../../../Common/TypeHelper'

type Props = {
  notices: string[]
}

export const NoticeListComponents = (props: Props): Nullable<JSX.Element> => {
  if (props.notices.length === 0) {
    return null
  }

  return <ul className="list-notice_01 _strong mt_4" data-testid={'block-notice-list'}>
    {props.notices.map((notice, i) => {
      return <li key={i}><span className="mark">※</span>{notice}</li>
    })}
  </ul>
}
